import { __makeTemplateObject } from '../../node_modules/tslib/tslib.es6.js';
import { jsxs, jsx } from 'react/jsx-runtime';
import { media, IconButton, SearchIcon, PersonIcon, BasketIcon } from '@elseu/sdu-titan';
import styled, { css } from 'styled-components';

/**
 * The styled component for the NavigationButtons
 */
var StyledNavigationButtons = styled.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), function (_a) {
  var theme = _a.theme;
  return css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    display: flex;\n    align-items: center;\n    gap: ", ";\n    width: 100%;\n    justify-content: flex-end;\n\n    ", "\n  "], ["\n    display: flex;\n    align-items: center;\n    gap: ", ";\n    width: 100%;\n    justify-content: flex-end;\n\n    ", "\n  "])), theme.spacing[4], media.greaterThan('s')(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n        flex: 1;\n    "], ["\n        flex: 1;\n    "]))));
});
/**
 * The styled component for the IconButton
 */
var StyledIconButton = styled(IconButton)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  padding: 0;\n"], ["\n  padding: 0;\n"])));
/**
 * The NavigationButtons component
 */
var NavigationButtons = function (_a) {
  var setIsSearchActive = _a.setIsSearchActive;
  return jsxs(StyledNavigationButtons, {
    children: [jsx(StyledIconButton, {
      icon: jsx(SearchIcon, {
        fontSize: 24
      }),
      label: "Zoeken",
      onClick: function () {
        return setIsSearchActive(true);
      }
    }), jsx(IconButton, {
      label: "Inloggen",
      icon: jsx(PersonIcon, {
        fontSize: 24
      }),
      href: "https://www.sdu.nl/shop/customer/account/login/",
      /** @ts-expect-error */
      target: "_self",
      rel: ""
    }), jsx(IconButton, {
      label: "Winkelmandje",
      icon: jsx(BasketIcon, {
        fontSize: 24
      }),
      href: "https://www.sdu.nl/shop/checkout/cart/",
      /** @ts-expect-error */
      target: "_self",
      rel: ""
    })]
  });
};
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;

export { NavigationButtons };
//# sourceMappingURL=NavigationButtons.js.map
